export default "__VITE_ASSET__DA$JfRCc__"